// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSingleColumn_root__1433B","layoutWrapperMain":"LayoutSingleColumn_layoutWrapperMain__S1ptJ"};